const A4_MM_DIMENSION = Object.freeze({
    WIDTH: 210,
    HEIGHT: 297,
    PADDING: 25
});
export default A4_MM_DIMENSION;
